import SelectionState from "state/selections/SelectionState";
import produce from "immer";

export const setDefinitionToState = (state, idx, definition) => {
  return produce(state, (draft) => {
    const selectedDefinitions = draft.definitions[SelectionState.UNCOMMITTED];
    if (definition === null) {
      selectedDefinitions.splice(idx, 1);
    } else {
      selectedDefinitions[idx] = definition;
    }
  });
};
export const removeDefinitionFromState = (state, definition) => {
  return produce(state, (draft) => {
    const uncommittedIdx = draft.definitions[
      SelectionState.UNCOMMITTED
    ].findIndex(({ key }) => key === definition.key);
    const committedIdx = draft.definitions[SelectionState.COMMITTED].findIndex(
      ({ key }) => key === definition.key
    );
    if (uncommittedIdx > -1) {
      draft.definitions[SelectionState.UNCOMMITTED].splice(uncommittedIdx, 1);
    }
    if (committedIdx > -1) {
      draft.definitions[SelectionState.COMMITTED].splice(committedIdx, 1);
    }
  });
};
